"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.step = void 0;
const tslib_1 = require("tslib");
require("../../../../TdWebtoolkitControls/controls/Wizard/Wizard");
const Utilities_1 = require("../../../../TdWebtoolkitControls/javascript/Utilities");
const Base_1 = require("../../../../TdWebtoolkitControls/model/Base");
const Instance_1 = require("../../../../TdWebtoolkitControls/model/Instance");
const lmsModel_1 = require("../../lms/lmsModel");
require("./stepNames");
const stepNames_1 = require("./stepNames");
exports.step = {
    name: stepNames_1.WizardStepNames[stepNames_1.WizardStepNames.checklist],
    nextPossibleSteps: [stepNames_1.WizardStepNames[stepNames_1.WizardStepNames.briefing], stepNames_1.WizardStepNames[stepNames_1.WizardStepNames.end]],
    canReRun: ($this) => {
        let globalStorage = $this.synWizard("getGlobalStorage");
        if (globalStorage["finished"] === true)
            return false;
        else
            return true;
    },
    run: ($this) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        let pathStorage = $this.synWizard("getPathStorage");
        // Check if terminal
        if (sessionStorage.getItem("visitorManagement.terminal") === "true")
            pathStorage["isTerminal"] = true;
        // Handle checklist
        let $contentDiv = $this.synWizard("getStepContentDiv");
        if (Utilities_1.synUtil.clientDeviceClass !== "phone")
            $contentDiv.css("box-sizing", "border-box").css("padding", "0 20%");
        const checklistTypeId = parseInt(Utilities_1.synUtil.Configs.getValueMandatory("visitormanagement.checklisttypeid"), 10);
        pathStorage["checklistTypeId"] = checklistTypeId.toString();
        $contentDiv.synChecklist();
        if (pathStorage["checklistDocId"] && pathStorage["checklistInstance"]) {
            try {
                Utilities_1.synUtil.beginAjaxProgress();
                let instance = yield Utilities_1.synUtil.getAJAXDataAsync({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("ChecklistGetInstance"),
                    requestData: JSON.stringify({ id: pathStorage["checklistId"], checkout: true, fordesigner: false }),
                });
                $contentDiv.synChecklist("setInstance", instance);
                $this.synWizard("enableNextButton");
                Utilities_1.synUtil.endAjaxProgress();
            }
            catch (error) {
                Utilities_1.synUtil.endAjaxProgress();
                Utilities_1.synUtil.Notifications.error(error);
            }
        }
        else {
            // Create new document
            try {
                let templateJSON = yield Utilities_1.synUtil.getAJAXDataAsync({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("InstanceTemplate") + checklistTypeId.toString() + "/" + (Base_1.PropertyPageMode.New).toString(),
                });
                let template = yield Instance_1.Instance.fromJSON(templateJSON);
                const locationId = sessionStorage.getItem("visitorManagement.locationId") || undefined;
                if (locationId) {
                    const locationField = Utilities_1.synUtil.Configs.getValue("visitormanagement.checklisttemplatelocationfield", undefined, checklistTypeId);
                    if (locationField)
                        template[locationField].value = locationId;
                }
                let requestOptions = {
                    instance: JSON.stringify(template.toJSON()),
                };
                Utilities_1.synUtil.beginAjaxProgress();
                let data = yield Utilities_1.synUtil.getAJAXDataAsync({
                    method: "PUT",
                    url: Utilities_1.synUtil.getWSUrl("InstanceCreate"),
                    requestData: requestOptions,
                });
                let instance = yield Instance_1.Instance.fromJSON(data);
                pathStorage["checklistDocId"] = instance.items["cgdocument.docid"].value;
                pathStorage["checklistId"] = instance.id.value;
                Utilities_1.synUtil.endAjaxProgress();
            }
            catch (error) {
                Utilities_1.synUtil.endAjaxProgress();
                Utilities_1.synUtil.Notifications.error(error);
            }
            // Set checklist instance
            try {
                Utilities_1.synUtil.beginAjaxProgress();
                let instance = yield Utilities_1.synUtil.getAJAXDataAsync({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("ChecklistGetInstance"),
                    requestData: JSON.stringify({ id: pathStorage["checklistId"], checkout: true, fordesigner: false }),
                });
                $contentDiv.synChecklist("setInstance", instance);
                $this.synWizard("enableNextButton");
                Utilities_1.synUtil.endAjaxProgress();
            }
            catch (error) {
                Utilities_1.synUtil.endAjaxProgress();
                Utilities_1.synUtil.Notifications.error(error);
            }
        }
        $contentDiv.on("clMandatoryFieldsAreSet", function (e) {
            $this.synWizard("nextStep");
        });
    }),
    persist: ($this) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        let $contentDiv = $this.synWizard("getStepContentDiv");
        let pathStorage = $this.synWizard("getPathStorage");
        let checklistSaveUrl = Utilities_1.synUtil.getWSUrl("ChecklistSaveInstance");
        let checklistCheckMandatoryUrl = Utilities_1.synUtil.getWSUrl("ChecklistCheckMandatory");
        let newInst = $contentDiv.synChecklist("getInstance");
        // Check mandatory fields
        try {
            yield Utilities_1.synUtil.getAJAXDataAsync({
                method: "POST",
                url: checklistCheckMandatoryUrl,
                requestData: {
                    instance: JSON.stringify(newInst),
                    id: pathStorage["checklistId"],
                }
            }, true, false);
            try {
                yield Utilities_1.synUtil.getAJAXDataAsync({
                    method: "PUT",
                    url: checklistSaveUrl,
                    requestData: {
                        instance: JSON.stringify(newInst),
                        id: pathStorage["checklistId"],
                        checkin: true,
                    },
                });
                pathStorage["checklistInstance"] = newInst;
                return Promise.resolve();
            }
            catch (err) {
                Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("connectionfailed"));
                return Promise.reject(err);
            }
        }
        catch (err) {
            if (err.responseJSON && err.responseJSON.ErrorNumber === 49) {
                Utilities_1.synUtil.Notifications.error(err.responseJSON.ErrorDisplayMessage);
                return Promise.reject("Checklist not all mandatory fields have a value");
            }
            else {
                Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("connectionfailed"));
                return Promise.reject(err);
            }
        }
    }),
    cleanup: ($this) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        // Delete created document
        let pathStorage = $this.synWizard("getPathStorage");
        if (pathStorage["checklistId"]) {
            let dataobj = {
                "cefunc.24forcedelete": true
            };
            yield Utilities_1.synUtil.executeMethodAsync({
                method: "cefunc.24",
                ids: [pathStorage["checklistId"]],
                parentId: undefined,
                relId: undefined,
                additionalData: dataobj,
            });
        }
    }),
    getNextStepName: ($this) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        let pathStorage = $this.synWizard("getPathStorage");
        let lesson = undefined;
        let checklistDocId = pathStorage["checklistDocId"];
        if (checklistDocId) {
            let lessonJSON = yield Utilities_1.synUtil.getAJAXDataAsync({
                url: Utilities_1.synUtil.getWSUrl("LmsGetLessonForVisitorObject") + checklistDocId,
            });
            lesson = yield lmsModel_1.LMSLesson.fromJSON(lessonJSON);
        }
        if (lesson) {
            pathStorage["lesson"] = lesson === null || lesson === void 0 ? void 0 : lesson.toJSON();
            return stepNames_1.WizardStepNames[stepNames_1.WizardStepNames.briefing];
        }
        else {
            return stepNames_1.WizardStepNames[stepNames_1.WizardStepNames.end];
        }
    }),
    hideBtnPrevious: true,
};
